var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWifiSignal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.61476 8.93945C9.25426 8.93945 9.87565 9.1075 10.4232 9.42792L10.645 9.55775C10.8132 9.65617 10.8428 9.88652 10.7049 10.024L8.81079 11.9129C8.69445 12.0289 8.50582 12.0289 8.38948 11.9129L6.50757 10.0362C6.37028 9.89927 6.3989 9.67009 6.56566 9.57094L6.78501 9.44051C7.33755 9.11198 7.96682 8.93945 8.61476 8.93945Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61472 5.4707C10.2056 5.4707 11.733 5.99845 12.9773 6.97577L13.1531 7.11389C13.2933 7.22401 13.3056 7.4315 13.1794 7.55734L12.0487 8.68498C11.9441 8.78927 11.7786 8.80125 11.66 8.71311L11.5221 8.61067C10.6818 7.98609 9.66839 7.65106 8.61472 7.65106C7.55457 7.65106 6.53529 7.99025 5.69211 8.622L5.55412 8.72539C5.43552 8.81425 5.26942 8.80255 5.16452 8.69794L4.03416 7.57072C3.90823 7.44514 3.92019 7.23818 4.05974 7.12785L4.23459 6.98962C5.48184 6.00358 7.01621 5.4707 8.61472 5.4707Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61477 2C11.1395 2 13.5538 2.89057 15.4648 4.52294L15.6279 4.66228C15.7598 4.77488 15.7675 4.97558 15.6448 5.09797L14.5177 6.22195C14.4085 6.33084 14.234 6.33847 14.1156 6.23952L13.9761 6.12283C12.4714 4.86472 10.5856 4.18035 8.61477 4.18035C6.63723 4.18035 4.74532 4.86943 3.23847 6.13541L3.09886 6.2527C2.98055 6.3521 2.80564 6.34466 2.69626 6.23557L1.56931 5.11176C1.44675 4.98954 1.45429 4.78918 1.5857 4.67646L1.7482 4.53708C3.66158 2.89589 6.08261 2 8.61477 2Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiSignal);
export default __webpack_public_path__ + "static/media/WifiSignal.e64e804ccc6206db8a80f0730893d262.svg";
export { ForwardRef as ReactComponent };